import React from 'react';
import { Tooltip } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';

const ActEnableUser = ({ userInfo, setUserInfo, setOpenEnable }) => {
  const handleClick = () => {
    setUserInfo(userInfo);
    setOpenEnable(true);
  };

  return (
    <Tooltip title="Kích hoạt">
      <CheckCircleOutlined
        onClick={handleClick}
        style={{
          fontSize: '18px',
          color: '#10b981',
          cursor: 'pointer',
          marginLeft: '8px'
        }}
      />
    </Tooltip>
  );
};

export default ActEnableUser;
